import {Routes} from '@angular/router';
import {LoginPageComponent} from './Pages/LoginPageComponent/LoginPageComponent';
import {ChooseRestaurantPageComponent} from './Pages/ChooseRestaurantPageComponent/ChooseRestaurantPageComponent';
import {
  RestaurantSelectedMainPageComponent
} from './Pages/RestaurantSelectedMainPage/RestaurantSelectedMainPage';
import {RestaurantNeedToBeSelected} from './RouteGuard/RestaurantNeedToBeSelected';
import {AccessNotAuthorizedPageComponent} from './Pages/AccessNotAuthorizedPage/AccessNotAuthorizedPage';
import {LogoutGuard} from './RouteGuard/LogoutGuard';
import {OrderSuccessCallback} from "./OrderCallbacksFromWan/OrderSuccessCallback.component";
import {OrderFailedCallback} from "./OrderCallbacksFromWan/OrderFailedCallback.component";
import {NoChildButSchoolPageComponent} from "./Pages/NoChildButSchoolPage/NoChildButSchoolPage.component";
import { NoMealMomentsErrorPageComponent } from './Pages/Errors/NoMealMomentErrorPage.component';
import { CustomerNotFoundPageComponent } from './Pages/Errors/CustomerNotFoundPage.component';
import { OrderNotAvailablePageComponent } from './Pages/Errors/OrderNotAvailablePageComponent';
// /order/*
const OrderRoutes: Routes = [
  {
    path: "order/success",
    component: OrderSuccessCallback
  },
  {
    path: "order/failed",
    component: OrderFailedCallback
  }
]

// /error/*
const ErrorRoutes: Routes = [
  {
    path: "error/no-mealmoments",
    component: NoMealMomentsErrorPageComponent
  },
  {
    path: "error/customer-not-found",
    component: CustomerNotFoundPageComponent
  },
  {
    path: "error/order-not-available",
    component: OrderNotAvailablePageComponent
  }
]


// /restaurant/*
const RestaurantRoutes: Routes = [
  {
    path: "restaurant/:id",
    component: RestaurantSelectedMainPageComponent,
    canActivate: [RestaurantNeedToBeSelected]
  },
  {
    path: "restaurant/:id/not-authorized",
    component: AccessNotAuthorizedPageComponent
  },
  {
    path: "restaurant/:id/school-no-childs",
    component: NoChildButSchoolPageComponent
  }
];

// /login & /logout
const AccessRoutes: Routes = [
  {
    path: "login",
    component: LoginPageComponent
  },
  {
    path: "logout",
    component: LogoutGuard,
  }
];

export const routes: Routes = [
  {
    path: "",
    component: ChooseRestaurantPageComponent,
    pathMatch: "full"
  },
  ...RestaurantRoutes,
  ...AccessRoutes,
  ...OrderRoutes,
  ...ErrorRoutes
];
